import React from "react";

const FullPageLayout = ({ children }) => (
  <div className="default-layout--container">{children}</div>
);

export default FullPageLayout;
